import { render, staticRenderFns } from "./compareDown2.vue?vue&type=template&id=407f7469&scoped=true&"
import script from "./compareDown2.vue?vue&type=script&lang=js&"
export * from "./compareDown2.vue?vue&type=script&lang=js&"
import style0 from "./compareDown2.vue?vue&type=style&index=0&id=407f7469&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407f7469",
  null
  
)

export default component.exports